var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPublishedOffersIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1434_6609)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.5 12.2494V1.74945C0.5 1.48423 0.605357 1.22988 0.792893 1.04234C0.98043 0.854805 1.23478 0.749448 1.5 0.749448H5.19C5.41843 0.742793 5.64226 0.814581 5.82421 0.952862C6.00615 1.09114 6.13525 1.28757 6.19 1.50945L6.5 2.74945H12.5C12.7652 2.74945 13.0196 2.8548 13.2071 3.04234C13.3946 3.22988 13.5 3.48423 13.5 3.74945V12.2494C13.5 12.5147 13.3946 12.769 13.2071 12.9565C13.0196 13.1441 12.7652 13.2494 12.5 13.2494H1.5C1.23478 13.2494 0.98043 13.1441 0.792893 12.9565C0.605357 12.769 0.5 12.5147 0.5 12.2494Z",
    stroke: "black",
    strokeOpacity: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1434_6609"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPublishedOffersIcon);
export default __webpack_public_path__ + "static/media/published_offers_icon.ca4014c090c41970dbf9fc1506697197.svg";
export { ForwardRef as ReactComponent };